module.exports = __webpack_public_path__ + "media/images/slider_img_sp_03-060f613579f796a358ae789098297e77.png";